// src/utils/manuscriptTemplateApi.js
//
// Changing the template on a manuscript that already exists, and undoing it.
// Both are author only — the API answers 403 `not_author` to anyone else (see
// "Changing a manuscript's template" in backend/routes/drafts.py).

import { getJSON, postJSON, putJSON } from './api';

export const listTemplates = () => getJSON('/api/manuscript-templates');

/**
 * Put `templateId` on the draft with its formatting (`theme`, a theme copy, or
 * null), recording the block ids the editor froze as regular text.
 */
export const changeTemplate = (draftId, templateId, theme, orphaned) =>
  putJSON(`/api/drafts/${draftId}/template`, {
    template_id: templateId,
    manuscriptTheme: theme,
    orphaned,
  });

/** Undo the last change. Answers with the restored template and the ids to release. */
export const revertTemplate = (draftId) => postJSON(`/api/drafts/${draftId}/template/revert`, {});
